import { secureGet, securePost, securePut } from "../../Config/ApiConfig";

export const getPayments = async ({ page, size }) => {
    const { data } = await secureGet('/payments?page=' + page + '&per_page=' + size)
    return data;
};

export const getProducts = async () => {
    const { data } = await secureGet('/payments/products')
    return data;
};

export const validatePromoCode = async (body) => {
    const { data } = await securePost('/payments/validate-promotion-code', body)
    return data;
};

export const getAutoChargeSettings = async () => {
    const { data } = await secureGet('/payments/settings')
    return data;
};

export const createCheckoutSession = async (body) => {
    const { data } = await securePost('/payments/checkout-session', body)
    return data;
};

export const getBillingDetails = async (body) => {
    const { data } = await secureGet('/payments/customer-portal', body)
    return data;
};
export const updateAutoChargeSettings = async (body) => {
    const { data } = await securePut('/payments/settings', body)
    return data;
};
